import React from 'react';

export const BookingIcon = (props) => <div className={`bw-icon ${props.iconName}`} />;

export default BookingIcon;
